<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('topics.viewFileHistory')"></page-title>
    </div>

    <jet-form-section>

        <template #form>
            <!-- Card File -->
            <form-card :title="$t('topics.fileHistory')" :description="$t('topics.fileHistoryDescription')">

                <div class="col-span-6">
                    <div class="flex flex-col">
                        <div v-for="offer in offers" :key="offer.uuid"
                             class="flex justify-between items-center border-b border-dotted pb-2 pt-2">
                            <div class="text-gray-500">V {{ offer.version }}</div>
                            <div>{{ offer.createdAt }}</div>
                            <div class="flex items-center gap-2">
                                <span v-if="offer.is_credit" class="inline-block bg-red-100 text-red-700 text-xs px-2 py-0.5 rounded-full">{{ $t("offers.type.credit") }}</span>
                                <span :class="{ 'text-red-600': offer.is_credit }">{{ $filters.currencyCHF(offer.cost) }}</span>
                            </div>
                            <div class="flex items-center">
                                <button type="button" @click="download(offer)" v-if="offer.filename">
                                    <CloudDownloadIcon
                                        class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                                </button>
                                <button v-if="offer.filename && isViewable(offer.filename)" type="button" @click="viewFile(offer.viewLink, offer.filename)" title="View" class="ml-2">
                                    <EyeIcon class="h-5 w-5 text-minplan-darkbeige hover:text-minplan-darkgreybeige" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <primary-button @click="cancel" class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.close") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

    <file-preview-modal
        :show="previewFile !== null"
        :file-url="previewFile?.url"
        :file-name="previewFile?.name"
        @close="previewFile = null"
    />

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { CloudDownloadIcon, EyeIcon } from "@heroicons/vue/outline";
import { downloadFile } from "@/Shared/Utils/downloader";
import FilePreviewModal from "@/Shared/Components/FilePreviewModal.vue";


export default defineComponent({
    props: ["offers", "topic"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        CloudDownloadIcon,
        EyeIcon,
        FilePreviewModal,
    },
    data() {
        return {
            previewFile: null,
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        download(offer) {
            downloadFile(offer.downloadLink, offer.filename);
        },
        isViewable(fileName) {
            if (!fileName) return false;
            const ext = fileName.toLowerCase().split('.').pop();
            return ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext);
        },
        viewFile(url, name) {
            const ext = name.toLowerCase().split('.').pop();
            if (['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'].includes(ext)) {
                window.Fancybox.show([{ src: url, type: "image" }]);
            } else {
                this.previewFile = { url, name };
            }
        },
    }
});
</script>

<style scoped></style>
